import { operatorStatusMap, secondsToDuration } from '@/views/call-system/common';

/* 话务系统 */
const callSystem = {
  namespaced: true,
  state: {
    operatorDetail: null, // 坐席人员详情
    operatorStatus: '', // 坐席人员状态
    callInfo: null, // 通话信息，接通电话时socket推送的数据
    callSeconds: 0, // 通话时长，秒
    durationInterval: -1, // 通话时长累加计时器
    insertInfo: null, // 强插信息
    listenInfo: null, // 监听信息
  },
  getters: {
    callDuration(state) {
      return secondsToDuration(state.callSeconds);
    },
  },
  mutations: {
    /* 保存当前登录用户对应的坐席人员详情 */
    SET_OPERATOR_DETAIL: (state, val) => {
      state.operatorDetail = val;
    },
    /* 设置坐席人员状态 */
    SET_OPERATOR_STATUS: (state, val) => {
      state.operatorStatus = val;
      // 接通电话后开始计时，结束通话时停止计时
      if (val == operatorStatusMap.incall) {
        state.callSeconds = 0;
        clearInterval(state.durationInterval);
        state.durationInterval = setInterval(() => {
          state.callSeconds++;
        }, 1000);
      } else if (val == operatorStatusMap.aftercall) {
        clearInterval(state.durationInterval);
      }
    },
    /* 设置通话信息 */
    SET_CALL_INFO: (state, val) => {
      state.callInfo = val;
    },
    /* 重置通话信息 */
    RESET_CALL_INFO: (state, val) => {
      clearInterval(state.durationInterval);
      state.callInfo = {};
      state.callSeconds = 0;
    },
    /* 设置强插信息 */
    SET_INSERT_INFO: (state, val) => {
      state.insertInfo = val;
    },
    /* 设置监听信息 */
    SET_LISTEN_INFO: (state, val) => {
      state.listenInfo = val;
    },
  },
};

export default callSystem;
